import { useState } from "react";
import { Modal, Typography, Form, Input, Button, Space, message } from "antd";
import { UserInfo } from "../../interface";
import { deleteUser } from "../../apiBridge";

interface Props {
  isOpen: boolean;
  user?: UserInfo;
  controller: React.Dispatch<React.SetStateAction<boolean>>;
  reloadController: React.Dispatch<React.SetStateAction<boolean>>;
}

const { Title, Text } = Typography;

const onFinishFailed = (errorInfo: any) => {
  console.log("Failed:", errorInfo);
};

const DeleteUserModal: React.FC<Props> = ({
  isOpen,
  user,
  controller,
  reloadController,
}) => {
  const [form] = Form.useForm();
  const [messageApi, contextHolder] = message.useMessage()

  const [loadingState, setLoadingState] = useState(false);

  const onFinishDeleteUser = async (values: any) => {
    if (user) {
      setLoadingState(true);
      const res = await deleteUser({ id: user.id, disabled: true });
      setLoadingState(false);
      if (res.status === 200) {
        messageApi.success('User deleted successfully')
        reloadController(true);
        controller(false);
      }
    }
  };

  return (
    <>
    {contextHolder}
    <Modal
      footer={null}
      maskClosable={false}
      closeIcon={false}
      centered
      open={isOpen && user !== undefined}
      width={380}
      afterOpenChange={(open) => {
        if (!open) {
          form.resetFields();
        }
      }}
    >
      <div style={{ marginBottom: 20 }}>
        <Title level={4}>Remove User</Title>
        <Text type="secondary">
          Are you sure you want to remove this user? This will archive the
          account.
        </Text>
      </div>
      <Form
        name="createuserform"
        layout="vertical"
        onFinish={onFinishDeleteUser}
        onFinishFailed={onFinishFailed}
        autoComplete="off"
        form={form}
        validateTrigger="onSubmit"
      >
        <Form.Item
          label="Type 'remove' to confirm remove"
          name="confirmation"
          rules={[
            { message: "Please type 'remove' to remove user." },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (value !== "remove") {
                  return Promise.reject(
                    new Error("Please type the word 'remove'")
                  );
                } else {
                  return Promise.resolve();
                }
              },
            }),
          ]}
        >
          <Input />
        </Form.Item>
        <div style={{ textAlign: "right" }}>
          <Space>
            <Button onClick={() => controller(false)}>Cancel</Button>

            <Form.Item style={{ margin: 0 }}>
              <Button
                type="primary"
                htmlType="submit"
                loading={loadingState}
                danger
              >
                Remove User
              </Button>
            </Form.Item>
          </Space>
        </div>
      </Form>
    </Modal>
    </>
  );
};

export default DeleteUserModal;
